{
  "byline": {
    "by": "By {{authors}}",
    "coAuthored": "Co-authored with {{authors}}",
    "and": "and"
  },
  "meta": {
    "readTime_one": "{{count}} min read",
    "readTime_other": "{{count}} min read",
    "published": "Published {{date}}",
    "updated": "Updated {{date}}",
    "category": "Category"
  },
  "donation": {
    "title": "Support independent journalism",
    "description": "Your contribution helps us keep reporting stories that matter.",
    "cta": "Make a donation",
    "coffeeTitle": "Buy us a coffee",
    "coffeeText": "A simple way to fuel our reporting: buy us a coffee on Buy Me a Coffee. Every cup counts.",
    "coffeeCta": "Support us on Buy Me a Coffee"
  },
  "share": {
    "title": "Share this story",
    "copyLink": "Copy link",
    "copied": "Link copied!",
    "twitter": "Share on Twitter",
    "facebook": "Share on Facebook"
  },
  "related": {
    "title": "Related stories"
  },
  "translation": {
    "availableIn": "Also available in",
    "pending": "Translation pending"
  },
  "author": {
    "articlesHeader": "Articles by {{name}}",
    "noArticles": "No published articles yet.",
    "articlesCount": "Articles",
    "avgReadTime": "avg"
  },
  "search": {
    "hint": "Search across all published stories in French, English, and Arabic.",
    "resultsCount_one": "{{count}} result for \"{{query}}\"",
    "resultsCount_other": "{{count}} results for \"{{query}}\"",
    "noResults": "No results for \"{{query}}\""
  }
}
